export default __webpack_public_path__ + "static/media/logout.4f47d67d.svg";